import { useState } from 'react';
import styles from './index.module.sass';
import plusSvg from '@@/search/images/plus.svg';
import successSvg from '@@/search/images/success.svg';
import classNames from 'classnames';
import { IStore } from '@/modules/mixing/components/mixing-by-params-modal/hooks';

export const TopFiltersBar = ({ stores , onSelectStore, onSelectAll, deselectAll }: { stores: IStore[], onSelectStore: (option: IStore) => void, onSelectAll: () => void, deselectAll: () => void }) => {
  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <span>поиск по выбранным складам</span>
        <span className={styles.select} onClick={onSelectAll}><b>+</b> выбрать все</span>
        <span className={styles.deselect} onClick={deselectAll}><b>-</b> отменить выбранные</span>
      </div>
      <div className={styles.warehouses}>
        {stores.map((item, i) => (
          <div
            className={classNames(styles.whItem, item.checked && styles.active)}
            onClick={() => onSelectStore(item)
            }
          >
            <img src={item.checked ? successSvg : plusSvg} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
